module.exports = __webpack_public_path__ + "img/宋臻.04666527.jpg";